import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';
import { AD_ACCOUNTS_SELECTION_POPUP } from 'src/views/AdAccountsSelectionPopup';

import { AccountsDataExtractionPopup } from './AccountsDataExtractionPopup';

export const ACCOUNTS_DATA_EXTRACTION_POPUP = Symbol('ACCOUNTS_DATA_EXTRACTION');

export const useAccountsDataExtractionPopup = () => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(ACCOUNTS_DATA_EXTRACTION_POPUP, AccountsDataExtractionPopup);
  });

  return useCallback(
    ({ account }) => {
      popups.closePopup(AD_ACCOUNTS_SELECTION_POPUP);

      return new Promise((resolve) => {
        popups.openPopup(ACCOUNTS_DATA_EXTRACTION_POPUP, {
          account,
          onClose: () => {
            resolve();
          },
        });
      });
    },
    [popups]
  );
};
